<template>
  <div>
    <label for="message">{{ lang.get('broadcasts.form.heading.message') }} {{ lang.get('miscellaneous.optional') }}</label>
    <markdown-editor
      id="message"
      name="message"
      :value="value"
      :markdown-guide-label="lang.get('miscellaneous.markdown_guide.label')"
    />
  </div>
</template>

<script>
import MarkdownEditor from '@/lib/components/Shared/MarkdownEditor';

export default {
  inject: ['lang'],
  props: {
    value: {
      type: String,
      default: ''
    },
  },
  components: {
    MarkdownEditor
  }
};
</script>
